import { countrySchema } from '@/common/constants/country-list';
import { t } from 'i18next';
import { z } from 'zod';

const VALUES_REGEX = /^[a-zA-Z0-9 _'"´''",;.#()/ºª]*$/g;

export const cardShippingAddressStepSchema = ({
  restrictSpecialCharacters,
  requiresDistrict,
}: {
  restrictSpecialCharacters?: boolean;
  requiresDistrict?: boolean;
} = {}) => {
  const requiredString = z.string().min(1, t('errors.input.required'));
  const defaultSchema = {
    addressLine1: requiredString,
    addressLine2: z.string(),
    zipCode: requiredString,
    city: requiredString,
    country: countrySchema,
    district: requiresDistrict ? requiredString : z.string().optional(),
  };

  if (restrictSpecialCharacters) {
    return z.object({
      ...defaultSchema,
      addressLine1: defaultSchema.addressLine1.regex(
        VALUES_REGEX,
        t('errors.input.invalid_characters')
      ),
      addressLine2: defaultSchema.addressLine2.regex(
        VALUES_REGEX,
        t('errors.input.invalid_characters')
      ),
      zipCode: defaultSchema.zipCode.regex(
        VALUES_REGEX,
        t('errors.input.invalid_characters')
      ),
      city: defaultSchema.city.regex(
        VALUES_REGEX,
        t('errors.input.invalid_characters')
      ),
    });
  }

  return z.object(defaultSchema);
};

export const limitLength = (length: number) => (val: string) =>
  val.slice(0, length);

export type TCardShippingAddressStepSchema = z.infer<
  ReturnType<typeof cardShippingAddressStepSchema>
>;
